module.exports = __webpack_public_path__ + "media/store/images/variable-fonts/variable-icon-1-380ba92567e2b3974aeb0898c45fccee.svg";